export default "__VITE_ASSET__CTDjf75H__"